import { Link } from 'react-router-dom'
import styled, { css } from 'styled-components'

interface RowOptionProps {
  selected?: boolean
}

export const MedicalViewsList = styled.ul`
  position: relative;
  width: 310px;

  background: ${({ theme }) => theme.zds.colors.neutral1000};
  box-shadow: 0px 4px 4px ${props => props.theme.colors.colorBlack29};
  border-radius: 0px 0px 4px 4px;
  overflow: hidden;
`

export const MedicalViewLink = styled(Link)<RowOptionProps>`
  position: relative;
  width: 100%;
  height: 40px;
  padding: 0 1rem;

  background: ${props => (props.selected ? props.theme.colors.color378ff7 : props.theme.zds.colors.neutral1000)};
  border-radius: 4px;
  transition: all 0.15s ease-in-out;
  text-decoration: none;

  display: flex;
  align-items: center;

  font-size: 12px;
  line-height: 15px;
  color: ${props => (props.selected ? props.theme.zds.colors.neutral1000 : props.theme.colors.color2d3139)};
  font-weight: ${props => (props.selected ? 700 : 500)};

  ${props =>
    !props.selected &&
    css`
      &:hover {
        background: rgba(0, 0, 0, 0.05);
      }
    `}
`
